module.exports = __webpack_public_path__ + "d024f9bd20375e2c3ea05a9dca8955b9-MMR-Website-Boat.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/home/assets/MMR-Website-Boat.gif
// module id = 847
// module chunks = 0